// Load modules

var Stringify = require('./stringify');
var Parse = require('./parse');


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};



//////////////////
// WEBPACK FOOTER
// ./~/qs/lib/index.js
// module id = 545
// module chunks = 0